<template>
    <div>
        <video ref="videoPlayer" class="vjs-big-play-centered video-js video"></video>
    </div>
</template>
  
<script>
import videojs from 'video.js';

export default {
    name: 'VideoPlayer',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null,
            FullscreenToggle: false
        }
    },
    mounted() {
        setTimeout(() => {
            this.player = videojs(this.$refs.videoPlayer, this.options, () => {
                this.player.log('onPlayerReady', this);
            });
        });
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    }
}
</script>

<style scoped>
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block;
}

.video-js .vjs-big-play-button {
    background-color: rgba(0, 0, 0, 0.6);
    /* font-size: 4em; */
    border-radius: 50%;
    height: 3.75rem !important;
    line-height: 3.75rem !important;
    width: 3.75rem !important;
    left: calc(103%/2);
    top: calc((100%)/2);
    transition: transform 0.5s ease;
}

.video {
    width: 100%;
    height: 80%;
}

.video-js .vjs-poster {
    background-size: 100% 100% !important;
    background-repeat: no-repeat;
}
</style>